//angular modules
//DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//soco modules
import { SocoAlertModule } from '@soco/alert';
import { SocoCommonModule } from '@soco/common';
import { SocoConfigurationModule } from '@soco/configuration';
import { SocoCoreModule } from '@soco/core';
import { SocoFormsModule } from '@soco/forms';
import { SocoHttpModule } from '@soco/http';
import { SocoModalModule } from '@soco/modal';

//components
//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { UserAddComponent } from './add/user-add.component';
import { UserEditComponent } from './edit/user-edit.component';
import { UserListComponent } from './list/user-list.component';

const MODULE_DIRECTIVES = [
    UserAddComponent,
    UserEditComponent,
    UserListComponent
];

@NgModule({
    imports: [
        //angular modules
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,

        //soco modules
        SocoAlertModule,
        SocoCommonModule,
        SocoConfigurationModule,
        SocoCoreModule,
        SocoFormsModule,
        SocoHttpModule,
        SocoModalModule
    ],
    exports: MODULE_DIRECTIVES,
    declarations: MODULE_DIRECTIVES
})
export class UserModule { }

